import { createAction } from '@reduxjs/toolkit';

export const openSavingOverlay = createAction('OPEN_SAVING_OVERLAY');
export const closeSavingOverlay = createAction('CLOSE_SAVING_OVERLAY');
export const setSavingOverlayText = createAction<string>('SET_SAVING_OVERLAY_TEXT');
export const unsetSavingOverlayText = createAction('UNSET_SAVING_OVERLAY_TEXT');

